











import { defineComponent, computed } from 'vue-demi';
import { resolveUrl } from '@zk/framework-vue';

export default defineComponent({
  props: {
    currentModel: {
      type: String,
      default: ''
    }
  },
  setup(props, { root }){
    function goSetting(){
      window.open(resolveUrl(`${root.$config.VUE_APP_PMS_URL}/setting/menu`));
    }
    const modelNameMap = computed(() => {
      return {
        dashboard: root.$t('navbar.Home'),
        // project: root.$t('navbar.project'),
        team: root.$t('navbar.teams'),
        roadmap: root.$t('navbar.roadmap'),
        version: root.$t('navbar.release'),
        backlog: root.$t('route.Backlog'),
        // work_list: root.$t('route.IssuesAirtable'),
        work_list: root.$t('route.Issues'),
        epic: root.$t('route.Epic'),
        cicd: root.$t('route.Jenkins'),
        overview: root.$t('route.Overview'),
        efficiency: root.$t('efficiency.page.title')
      };
    });
    const modelName = computed(() => {
      return modelNameMap.value[props.currentModel];
    });
    return {
      goSetting,
      modelName
    };
  }
});
